import {StakeInputParser} from "./StakeInputParser"

window.StakeInputParser = new StakeInputParser(UseCommaAndDotAsDecimalSeparator ? ['.', ','] : [DecimalSeparator], DefaultNumberFormat);